import dayjs from "dayjs";
import { formatDateIfValid } from "./formatDateIfValid";

export const getObtainableFromValue = (
  dateValue?: string | null,
  textValue?: string | null
): string | null => {
  const text = textValue || null;

  if (dateValue) {
    const isExpired = dayjs().diff(dateValue, "month") > 12;
    const formattedDate = isExpired ? null : (formatDateIfValid(dateValue) as string | null);

    if (formattedDate && text) {
      return `${formattedDate} (${text})`;
    }

    if (formattedDate) {
      return formattedDate;
    }

    return text;
  }

  return text;
};